import { LOCALE } from '../../utils/AppConstants';

const TODAY = new Date();
const LAST_MONTH = new Date(TODAY.getFullYear(), TODAY.getMonth() - 1, TODAY.getDate());

const lastMonthString =
    `${LAST_MONTH.getFullYear().toString().padStart(2, '0')}-` +
    `${(LAST_MONTH.getMonth() + 1).toString().padStart(2, '0')}-` +
    `${LAST_MONTH.getDate().toString().padStart(2, '0')}`;

const MLI_SESSION_CORRELATION_ID = '123-456-ABC-DEF';

export const AEM_CONTENT = {
    data: {
        'mp-bankvalidationerrors': {
            validBranch: 'Enter a valid branch #.',
            validAccount: 'Enter a valid account #.',
            validInstitution: 'Enter a valid institution #.',
            bankValidationMessage: 'Something below is missing or wrong.',
        },
        'mp-whoiscovered': {
            descriptionOne: '<p>You can cover your family members, if they are in the following groups:</p>\n',
            headingFive: 'Adding other family members',
            descriptionFive:
                "<p>You can cover other family members, such as a niece, nephew, grandchild, or sibling who lives with you. Your family member must also:</p>\n<ul>\n<li>depend on you for money or care</li>\n<li>not be married</li>\n<li>not work full-time</li>\n<li>be under your plan’s age limit</li>\n</ul>\n<p>If you want to cover one of these family members, call us or send us a note online. We'll be happy to help.</p>\n",
            headingOne: 'Family coverage',
            descriptionThree:
                '<p>You can cover your child. The child must be your natural child, adopted child, or a stepchild who lives with you. The child must also be:</p>\n<ul>\n<li>a dependent</li>\n<li>not married</li>\n<li>notworking full-time</li>\n<li>be under the age limit (typically, a child must be under 19, but&nbsp; &nbsp;check the details of your plan.</li>\n</ul>\n',
            headingTwo: 'Spouse',
            descriptionTwo:
                '<p>You can cover your spouse. Your spouse may be the person you’re legally married to. Or they may be someone you’ve been living with in a marriage-like relationship (common-law spouse). You may have a waiting period for a common-law spouse.</p>\n<p>You may only cover one spouse at a time.</p>\n',
            headingThree: 'Child',
            headingFour: 'Over-age child',
            descriptionFour:
                '<p>You may be able to cover a child who is older than the age limit. To find out the age limit, please contact your plan sponsor.</p>\n<p>To cover an over-age child, they must be either a:</p>\n<p><b>Student</b></p>\n<p>You can cover a student who is older than the usual age limit. The student must be:</p>\n<ul>\n<li>not married</li>\n<li>not working full-time</li>\n<li>going full-time to an accredited school, college or university</li>\n<li>under the age of {maxAge}.</li>\n</ul>\n<p><b>or a Disabled child</b></p>\n<p>You can cover a disabled child who is older than the age limit. The child must be:</p>\n<ul>\n<li>not married</li>\n<li>have a disability</li>\n<li>not be able to work full-time.</li>\n</ul>\n<p>After adding the over-age child, we may ask you to provide proof the child is eligible.</p>\n',
        },
        'mp-contactinfo': {
            address2Label: 'Address 2 (Optional)',
            contactPaMessage: 'Contact your plan administrator to update.',
            countryLabel: 'Country',
            pageTitle: 'My contact information',
            provinceLabel: 'Province',
            phoneNumberPlaceholder: '(111) 222-3333',
            postalCodeLabel: 'Postal code',
            postalCodePlaceholder: 'N1N 1N1',
            addressLabel: 'Address',
            phoneNumberLabel: 'Phone number',
            zipCodeLabel: 'Zip Code',
            addAddressButton: 'Add address',
            zipCodePlaceholder: 'Enter Zip Code',
            cityLabel: 'City',
            addressNotFound: 'I cannot find my address. Let me type it in.',
            address1Label: 'Address 1',
            header: 'My contact information',
            stateLabel: 'State',
            InformationMessage: '<p>All information is required unless marked as optional.</p>\n',
            streetAddressPlaceholderLabel: 'Street Address',
            apartmentUnitNumberLabel: 'Apartment or unit number',
            addPhoneNumberButton: 'Add phone number',
        },
        'mp-provinces': {
            ab: 'AB',
            bc: 'BC',
            ns: 'NS',
            nt: 'NT',
            nu: 'NU',
            qc: 'QC',
            nb: 'NB',
            mb: 'MB',
            pe: 'PE',
            sk: 'SK',
            yt: 'YT',
            nl: 'NL',
            on: 'ON',
        },
        'mp-landing': {
            myFamilyTitle: 'My Family',
            updateYourEmailAddress: 'Update your email address',
            mobileLeftTabScrollButtonAriaLabel: 'Scroll tab list left',
            myPersonalInfoHOne: 'My personal information',
            addSpouse: 'Add a spouse',
            pageTitle: 'Manulife Member Profile',
            changeDependentCob: 'Change your family member’s other coverage (coordination of benefits)',
            contactPaMessagePersonalInfo: '<p>Contact your plan administrator to:</p>\n',
            myFamilyHOne: 'My family',
            updateYourBankAccount: 'Update your bank account',
            personalInfoTab: 'My personal information',
            updateYourPhoneNumber: 'Update your phone number',
            changeDependentStudentStatus: 'Update your child’s student status',
            updateFamilyMembersText:
                'If something big has happened in your life (i.e. added a new family member, relationship changes), you can make changes to your coverage. ',
            addFamilyMember: 'Add a family member',
            myPersonalInfoTitle: 'My Personal Information',
            addFamilyMemberHOne: 'Add a family member',
            welcomeMessage: '<p>Hi {fName}!</p>\n',
            contactPAMessagePersonal: '<p>Contact your plan administrator to:</p>\n',
            familyMembersText: 'You can cover your family members. ',
            manageFamilyMemberHOne: 'Manage my plan',
            mobileRightTabScrollButtonAriaLabel: 'Scroll tab list right',
            removeFamilyMember: 'Remove a family member',
            whosCovered: "Who's covered?",
            contactPAMessageFamily: '<p>Contact your plan administrator to:</p>\n',
            myFamilyTab: 'My family',
            contactCustomerServiceAlertText:
                'Unfortunately, you are unable to make your plan update at this time. Please contact us for assistance at',
            changeCoverage: 'Change your coverage',
            addChild: 'Add a child',
            updateYourPostalAddress: 'Update your postal address',
        },
        'mp-bankinfo': {
            contactPaMessage: 'Contact your plan administrator to update.',
            personalCheque: 'Personal cheque',
            chequeImagePath: '/gb-memberprofile/en/master/images/PersonalCheque.svg',
            chequeAltText:
                'Example of a cheque showing the branch number (5 digit group after the cheque number), followed by the institution number (3 digit group) and then account number (the last 7-12 digits, after the branch number).',
            onlineInstructionOne: 'Sign in to your online bank account.',
            bankNotFound: 'Not found',
            onlineInstructions:
                '<ul>\n<li>Sign in to your online bank account.</li>\n<li>Choose the account you want to use to receive direct deposit.</li>\n<li>Find your account information on your account page.</li>\n</ul>\n',
            addBankButton: 'Add bank information',
            institutionLabel: 'Institution #',
            onlineInstructionThree: 'Find your account information on your account page.  ',
            bankNameLabel: 'Bank name',
            header: 'My banking information',
            bankInformationMessage:
                '<p>We use your banking information to pay your online claims. With your banking information, we can send a claim payment right to your bank account.</p>\n',
            online: 'Online',
            accordianTitle: 'Where can I find my banking information?',
            onlineInstructionTwo: 'Choose the account you want to use to receive direct deposit.',
            accountLabel: 'Account #',
            branchLabel: 'Branch #',
        },
        'mp-states': {
            newYorkStateLabel: 'New York',
            palauStateLabel: 'Palau',
            michiganStateLabel: 'Michigan',
            northernMarianaIslandsStateLabel: 'Northern Mariana Islands',
            massachusettsStateLabel: 'Massachusetts',
            washingtonStateLabel: 'Washington',
            delawareStateLabel: 'Delaware ',
            wyomingStateLabel: 'Wyoming',
            virginIslandsStateLabel: 'Virgin Islands',
            ohioStateLabel: 'Ohio',
            micronesiaStateLabel: 'Micronesia State ',
            puertoRicoStateLabel: 'Puerto Rico',
            maineStateLabel: 'Maine',
            wisconsinStateLabel: 'Wisconsin',
            vermontStateLabel: 'Vermont ',
            northCarolinaStateLabel: 'North Carolina',
            illinoisStateLabel: 'Illinois',
            nebraskaStateLabel: 'Nebraska',
            southDakotaStateLabel: 'South Dakota',
            utahStateLabel: 'Utah',
            kansasStateLabel: 'Kansas',
            southCarolinaStateLabel: 'South Carolina',
            minnesotaStateLabel: 'Minnesota',
            floridaStateLabel: 'Florida',
            nevadaStateLabel: 'Nevada',
            idahoStateLabel: 'Idaho',
            alaskaStateLabel: 'Alaska',
            kentuckyStateLabel: 'Kentucky',
            americanSamoaStateLabel: 'American Samoa',
            westVirginiaStateLabel: 'West Virginia',
            dcStateLabel: 'DC',
            oregonStateLabel: 'Oregon',
            newJerseyStateLabel: 'New Jersey',
            newHampshireStateLabel: 'New Hampshire',
            rhodeIslandStateLabel: 'Rhode Island',
            montanaStateLabel: 'Montana',
            pennsylvaniaStateLabel: 'Pennsylvania',
            texasStateLabel: 'Texas',
            marshallIslandsStateLabel: 'Marshall Islands',
            coloradoStateLabel: 'Colorado',
            newMexicoStateLabel: 'New Mexico',
            connecticutStateLabel: 'Connecticut',
            georgiaStateLabel: 'Georgia',
            hawaiiStateLabel: 'Hawaii',
            iowaStateLabel: 'Iowa',
            missouriStateLabel: 'Missouri',
            oklahomaStateLabel: 'Oklahoma',
            alabamaStateLabel: 'Alabama',
            californiaStateLabel: 'California',
            mississippiStateLabel: 'Mississippi',
            arkansasStateLabel: 'Arkansas',
            guamStateLabel: 'Guam',
            northDakotaStateLabel: 'North Dakota',
            tennesseeStateLabel: 'Tennessee',
            virginiaStateLabel: 'Virginia',
            indianaStateLabel: 'Indiana',
            louisianaStateLabel: 'Louisiana',
            marylandStateLabel: 'Maryland',
            arizonaStateLabel: 'Arizona',
        },
        'mp-common': {
            select: 'Select',
            addButton: 'Add',
            spouse: 'Spouse',
            cancelButton: 'Cancel',
            dateOfBirthLabel: 'Date of birth',
            editButton: 'Edit',
            closeButton: 'Close',
            otherBenefitCoverage: 'Other benefits coverage',
            ariaManulifeLogo: 'Manulife logo, Open the plan member secure site homepage',
            updateButton: 'Update',
            saveButton: 'Save',
            you: 'You',
            ariaTooltip: 'Tooltip',
            child: 'Child',
        },
        'mp-validationmessages': {
            dateOfBirthInvalid: 'Oops! This date doesn’t look right. Check it and try again.',
            errorOverSixtyDays: 'You can only use this option within 60 days of joining your new plan.',
            overageDependent: 'Your child is over the maximum age to be covered under your plan.',
            certifyCheckBox: 'Confirm that the information you’ve given is complete and true.',
            invalidAcctNo: 'Check what you typed and try again.',
            lastNameblank: 'Enter a valid last name',
            invalidZipCode: "Oops! This zip code doesn't look right. Check it and try again.",
            cobPolicyBlank: 'Enter a plan valid contract number.',
            duplicateSpouse: "You've already added a spouse.",
            sexBlank: 'Choose the sex',
            emailInvalid: 'Enter a valid email',
            studentCoverageExtensionReasonBlank: 'Select a reason for extending coverage',
            errorSummaryMessage: 'Something below is missing or wrong.',
            invalidPostalCode: 'Oops! This postal code doesn’t look right. Check it and try again.',
            addressChg: 'To change your address, contact your plan administrator.',
            missingInfo: 'Oops you need to fill this in.',
            firstNameBlank: 'Enter a valid first name',
            relationshipBlank: 'Choose the relationship',
            emailBlank: 'Email is required',
            errorSummaryTitle: 'Error',
            addTerminatedFamilyMemberError: 'We have this family member on file as terminated.',
            errorOverThirtyOneDays:
                "Sorry! It's been more than 31 days. Please contact  your plan administrator to add dependent",
            reasonForAdditionBlank: 'Choose a reason for addition.',
            cobProviderBlank: 'Choose a provider.',
            missingCoverageStartDate: 'Please enter coverage start date',
            minDigits: 'This needs to be 10 digits.',
            cobCoverageSelectBlank: 'Choose an option.',
            dateOfBirthBlank: 'Enter the date of birth.',
            futureDateOfBirth: 'The date of birth has to be in the past.',
            cobBenefitBlank: 'Please select benefit coverage',
            cobCertBlank: 'Enter a valid certificate number.',
            reasonForCoverageBlank: 'Choose a reason for extending coverage.',
            duplicateChild:
                "You've already added a child with this name and date of birth. Check your information and make the appropriate changes. ",
        },
        'mp-email': {
            contactPaMessage: 'Contact your plan administrator to update.',
            emailAddressLabel: 'Email address',
            header: 'My email address',
            addEmailButton: 'Add email address',
        },
        'mp-familymember': {
            coverageStartDateLabel: 'Coverage start date',
            cobToolTip:
                '<p>If they are, letting us know can save you money. The other plan may pay the part your plan deos not pay. So, you could get back up to 100% of the expense.That can save you money. We can help coordinate the two&nbsp; plans.</p>\n',
            sendDocuments: 'Send documents:',
            childLabel: 'Child',
            reasonSpousesChild: "Spouse's child",
            noneNoCoverageLabel: 'None - no coverage',
            disabledMessage:
                'To extend coverage for a child with a disability, have your doctor fill out this form for you and send it back to us.',
            extendCoverageReasonPlaceholder: 'Select one',
            ReasonChangeInSpouseCoverage: 'Change in spouse coverage',
            reasonBirth: 'Birth',
            reasonAdoption: 'Adoption',
            fullNameLabel: 'Full name',
            reasonJoiningMyNewPlan: 'Joining my new plan',
            disabledFormPath: '/GBPlanMemberUI/Secured/FormsBrochures/PDFForm.aspx?Action=IR&FormName=GL0514',
            sendFileText: 'Send the forms through the site via',
            disabledFormText: 'Request for overage disabled child coverage form',
            cobYes: 'Yes',
            contractNumber: 'Contract number',
            maleLabel: 'Male',
            coveredStudentMessage: 'Coverage will end soon',
            editFamilyMemberMessage: '<p>All information is required unless marked as optional</p>\n',
            cobType: 'What kind of coverage',
            ReasonRegainingCustody: 'Regaining custody of child',
            lastNameLabel: 'Last name',
            noOtherPlanCoverage: 'No other plan coverage',
            fullTimeStudentLabel: 'Full-time student',
            ReasonMaritialStatusChange: 'Maritial status change',
            benefitCardHeader: 'Where to find your other Manulife plan contract and member certificate ID.',
            benefitCardInstructions:
                'You can find the 7 digit plan contract ID on the left side of the benefits card. You can find the member certificate ID on the right side of the benefits card.',
            mmbLifeEventPath: '/LifeEvent',
            sendFilePath: '/GBPlanMemberUI/Secured/SendFiles.aspx',
            dropDownPlaceholder: 'Choose one',
            extendStudentButton: 'Extend coverage',
            ProviderManulife: 'Manulife',
            spouseLabel: 'Spouse',
            dateLabelOverAgeChildReturningToSchool: 'Date child went back to school',
            providerType: "Who's their provider",
            extendCoverageTooltip:
                '<p>If they are disabled or are going to college or university, they can remain or be added back on your plan until they turn {maxAge}. You just need to let us know. To do so click on the Extend Coverage or Edit button. Then select your response under &quot;Reason for extending coverage&quot;.</p>\n',
            declarationMessage:
                '<p>By clicking here, you confirm that the information you’ve given is complete and true.</p>\n',
            coverageDateTooltip:
                '<p>This date determines when your family member’s coverage starts.&nbsp;You can add a new family member to your plan within 31 days of the event (reason for addition) or within 60 days of joining your new plan with Manulife.<br>\n&nbsp;<br>\nIf the event happened more than 31 days in the past, please contact your plan administrator to add your family member to your plan.</p>\n',
            studentMessage: 'Coverage has ended',
            reasonForAdditionLabel: 'Reason for addition',
            dateLabelJoiningMyNewPlan: "Date they're joining my plan",
            addFamilyMemberMessage: 'All information is required unless marked as optional',
            ReasonOverageChild: 'Overage child returning to school',
            addFamilyMemberHeader: 'Add a family member',
            cobLabel: 'Are they covered under another plan?',
            sex: 'Sex',
            childStatusText: 'Your child is {age} and no longer covered.',
            dateLabelSpousesChild: 'Date child moved in',
            alternativeAddress: 'Or send it to the address listed on the form.',
            femaleLabel: 'Female',
            childAgeText: 'Your child is {age}.',
            cobNo: 'No',
            reasonForExtendingCoverageLabel: 'Reason for extending coverage',
            sexTooltip: '<p>Select current biological sex (this is an important factor in pricing insurance).</p>\n',
            certificateNumber: 'Certificate number',
            ProviderOther: 'Other',
            disabledLabel: 'Disabled',
            editFamilyMemberHeader: 'Edit a family member',
            firstNameLabel: 'First name',
            relationshipLabel: 'Relationship',
        },
        'mp-timeoutmodal': {
            approachTimeoutHeaderAltText: 'Timeout warning',
            subHeaderLineOne: 'Your session will time out in 1 minute.',
            buttonOne: 'Sign me out',
            subHeaderLineThree: "We'll sign you out in 1 minute.",
            buttonTwo: 'Keep me here',
        },
        'mp-countries': {
            usa: 'United States of America',
            canada: 'Canada',
        },
        'gbpm-cscphonenumber': {
            callCenterPhoneNumber: '1-800-268-6195',
        },
        'member-common': {
            timeoutHeader: 'Your session will be timed out in {{seconds}} seconds!',
            timeoutMsg: "We'll sign you out in {{seconds}} seconds",
            timedoutHeader: 'Your session has expired!',
            timedoutMsg: 'We have signed you out',
        },
    },
};

// file deepcode ignore HardcodedNonCryptoSecret: <This is only mock data>
export const JWT_MOCK_DATA = {
    default:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImRlZmF1bHQiLCJsYW5ndWFnZSI6ImVuLUNBIiwibG9jYXRpb25OdW0iOiIwMDEiLCJjbGFzc051bSI6IjAwMSIsInBsYW5OdW0iOiJBIiwiZ3JvdXAiOiIwMDk3NTAwIn0sIkNJQU0iOnsiYW1yIjpbIm90cCIsInB3ZCJdLCJjaWFtU2Vzc2lvblN0ZXB1cFN0YXRlcyI6W119LCJpYXQiOjE2MDUyMDY5NzAsImV4cCI6MTcwNTIwNjk2OX0.5aaobZ1Z0-cw7cNG2sPfsQTLqmoc_DUUy_626unBRTU',
    default_fr:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImRlZmF1bHQiLCJsYW5ndWFnZSI6ImZyLUNBIiwibG9jYXRpb25OdW0iOiIwMDEiLCJjbGFzc051bSI6IjAwMSIsInBsYW5OdW0iOiJBIiwiZ3JvdXAiOiIwMDk3NTAwIn0sIkNJQU0iOnsiYW1yIjpbIm90cCIsInB3ZCJdLCJjaWFtU2Vzc2lvblN0ZXB1cFN0YXRlcyI6W119LCJpYXQiOjE2MDUyMDY5NzAsImV4cCI6MTcwNTIwNjk2OX0.SmRAr-sBtT67wL5Sd5TshZIQyW47CofAEzPShFk7FJI',
    default_csr:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImNzciIsImxhbmd1YWdlIjoiZW4tQ0EiLCJsb2NhdGlvbk51bSI6IjAwMSIsImNsYXNzTnVtIjoiMDAxIiwicGxhbk51bSI6IkEiLCJncm91cCI6IjAwOTc1MDAifSwiQ0lBTSI6eyJhbXIiOlsib3RwIiwicHdkIl0sImNpYW1TZXNzaW9uU3RlcHVwU3RhdGVzIjpbXX0sImlhdCI6MTYwNTIwNjk3MCwiZXhwIjoxNzA1MjA2OTY5fQ.uwV4d88yLiHg90DQ0Mqx8pBV53xI0o2IJLJ8NE0lFH4',
    default_not_stepped_up:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImRlZmF1bHQiLCJsYW5ndWFnZSI6ImVuLUNBIiwibG9jYXRpb25OdW0iOiIwMDEiLCJjbGFzc051bSI6IjAwMSIsInBsYW5OdW0iOiJBIiwiZ3JvdXAiOiIwMDk3NTAwIn0sIkNJQU0iOnsiYW1yIjpbInB3ZCJdLCJjaWFtU2Vzc2lvblN0ZXB1cFN0YXRlcyI6W119LCJpYXQiOjE2NjAwNTk4ODUsImV4cCI6MTY2MDA2MDc4NX0.4Xeg3oFiqJ-wRkXpMB3bCYcdU1lDKmN6THBsHY2NWqk',
    default_fr_not_stepped_up:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImRlZmF1bHQiLCJsYW5ndWFnZSI6ImZyLUNBIiwibG9jYXRpb25OdW0iOiIwMDEiLCJjbGFzc051bSI6IjAwMSIsInBsYW5OdW0iOiJBIiwiZ3JvdXAiOiIwMDk3NTAwIn0sIkNJQU0iOnsiYW1yIjpbInB3ZCJdLCJjaWFtU2Vzc2lvblN0ZXB1cFN0YXRlcyI6W119LCJpYXQiOjE2NjAwNTk4ODUsImV4cCI6MTY2MDA2MDc4NX0.g7WlXSqgN83qLD9zsGHmE8CWSyL89oG_gx1c2nw0OMw',
    default_csr_not_stepped_up:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImNzciIsImxhbmd1YWdlIjoiZW4tQ0EiLCJsb2NhdGlvbk51bSI6IjAwMSIsImNsYXNzTnVtIjoiMDAxIiwicGxhbk51bSI6IkEiLCJncm91cCI6IjAwOTc1MDAifSwiQ0lBTSI6eyJhbXIiOlsicHdkIl0sImNpYW1TZXNzaW9uU3RlcHVwU3RhdGVzIjpbXX0sImlhdCI6MTY2MDA1OTg4NSwiZXhwIjoxNjYwMDYwNzg1fQ.I6klurXXYE3C9vlonDHMx2WKpFraWBQYOQTzPYxWU_I',
    maxSession:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjI5MTk0MTgiLCJjZXJ0aWZpY2F0ZSI6IjEwIiwiY2xpZW50TnVtYmVyIjoiMDA5NzUwMCIsInJvbGUiOiJkZWZhdWx0IiwibGFuZ3VhZ2UiOiJlbi1DQSIsImxvY2F0aW9uTnVtIjoiMDEwIiwiY2xhc3NOdW0iOiIwMTAiLCJwbGFuTnVtIjoiQSIsImdyb3VwIjoiMDA5NzUwMCJ9LCJDSUFNIjp7Im1heFNlc3Npb25FeHBpcmF0aW9uVGltZSI6IjIwMjQtMDEtMTRUMDQ6NDA6MDlaIn0sImlhdCI6MTYxMDYzODcwMSwiZXhwIjoxNzA1MjA2OTY5fQ.abgwVAuc8CxSKsTp6muBcmNkqnhfy_hlEFuDlBhLnyE',
    refreshTest:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjI5MTk0MTgiLCJjZXJ0aWZpY2F0ZSI6IjEwIiwiY2xpZW50TnVtYmVyIjoiMDA5NzUwMCIsInJvbGUiOiJkZWZhdWx0IiwibGFuZ3VhZ2UiOiJlbi1DQSIsImxvY2F0aW9uTnVtIjoiMDEwIiwiY2xhc3NOdW0iOiIwMTAiLCJwbGFuTnVtIjoiQSIsImdyb3VwIjoiMDA5NzUwMCJ9LCJpYXQiOjE2MTA2Mzg3MDEsImV4cCI6MTYxMDYzOTYwMX0.Cj_nNrSzCYr9bqoa4MSNz0uStKbNqqEzyhiaaqz9HPk',
    refreshTestNew:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjI5MTk0MTgiLCJjZXJ0aWZpY2F0ZSI6IjEwIiwiY2xpZW50TnVtYmVyIjoiMDA5NzUwMCIsInJvbGUiOiJkZWZhdWx0IiwibGFuZ3VhZ2UiOiJlbi1DQSIsImxvY2F0aW9uTnVtIjoiMDEwIiwiY2xhc3NOdW0iOiIwMTAiLCJwbGFuTnVtIjoiQSIsImdyb3VwIjoiMDA5NzUwMCJ9LCJpYXQiOjE2ODkxOTcwNDksImV4cCI6MTY4OTE5Nzk0OX0.vZz-qn_8WjhxYe0nbYgOpgJ2hhlVnO9TNO8hSlUZCm0',
    refreshTestCiam:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjI5MTk0MTgiLCJjZXJ0aWZpY2F0ZSI6IjEwIiwiY2xpZW50TnVtYmVyIjoiMDA5NzUwMCIsInJvbGUiOiJkZWZhdWx0IiwibGFuZ3VhZ2UiOiJlbi1DQSIsImxvY2F0aW9uTnVtIjoiMDEwIiwiY2xhc3NOdW0iOiIwMTAiLCJwbGFuTnVtIjoiQSIsImdyb3VwIjoiMDA5NzUwMCJ9LCJDSUFNIjp7InNlc3Npb25SZWYiOiIxMjM0NSJ9LCJpYXQiOjE2ODkxOTcwNDksImV4cCI6MTY4OTE5Nzk0OX0.gIu1iUvRm1eLHOgU-87id_YCNJXd1iRs2mgQC4W7eVI',
    refreshTestNewCiam:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjI5MTk0MTgiLCJjZXJ0aWZpY2F0ZSI6IjEwIiwiY2xpZW50TnVtYmVyIjoiMDA5NzUwMCIsInJvbGUiOiJkZWZhdWx0IiwibGFuZ3VhZ2UiOiJlbi1DQSIsImxvY2F0aW9uTnVtIjoiMDEwIiwiY2xhc3NOdW0iOiIwMTAiLCJwbGFuTnVtIjoiQSIsImdyb3VwIjoiMDA5NzUwMCJ9LCJDSUFNIjp7InNlc3Npb25SZWYiOiIxMjM0NSJ9LCJpYXQiOjE2MTA2Mzg3MDEsImV4cCI6MTYxMDYzOTYwMX0.KuxwEi--Pzzr7st7bJrPpElagyoRuoY9WOTuJLzdlC8',
    partial:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiTUVNQkVSX1BBUlRJQUxfSldUIiwiSWRlbnRpdHkiOnsibGFuZ3VhZ2UiOiIifSwiQ0lBTSI6eyJhbXIiOlsib3RwIiwicHdkIl19LCJpYXQiOjE2OTYzNDYwNzAsImV4cCI6MTY5NjM0Njk3MH0.trIBvLda2qb2baCMS_84VVm_rc-2AqY7ruD_0Pv2w2s',
    default_with_Ciam_and_entityId:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZGVudGl0eSI6eyJtZW1iZXJJZCI6IjEyMzQ1NjciLCJjZXJ0aWZpY2F0ZSI6IjEiLCJjbGllbnROdW1iZXIiOiIwMDk3NTAwIiwicm9sZSI6ImRlZmF1bHQiLCJsYW5ndWFnZSI6ImVuLUNBIiwibG9jYXRpb25OdW0iOiIwMDEiLCJjbGFzc051bSI6IjAwMSIsInBsYW5OdW0iOiJBIiwiZ3JvdXAiOiIwMDk3NTAwIn0sIkNJQU0iOnsidXVpZCI6Im1vY2stdXVpZC0xMjM0IiwiYW1yIjpbInB3ZCJdLCJjaWFtU2Vzc2lvblN0ZXB1cFN0YXRlcyI6W119LCJTU08iOnsiZW50aXR5X2lkIjoidGVzdC1lbnRpdHktaWQifSwiaWF0IjoxNjYwMDU5ODg1LCJleHAiOjE2NjAwNjA3ODV9.KD68Dq2eVEub1UHIebWNwetVrYwXqbanuL0QRAKVVwY',
};

export const TOKENS_DATA = {
    tokens: {
        'gb-authorization': JWT_MOCK_DATA.default,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },
    tokens_fr: {
        'gb-authorization': JWT_MOCK_DATA.default_fr,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },
    tokens_csr: {
        'gb-authorization': JWT_MOCK_DATA.default_csr,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },

    tokens_not_stepped_up: {
        'gb-authorization': JWT_MOCK_DATA.default_not_stepped_up,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },

    tokens_fr_not_stepped_up: {
        'gb-authorization': JWT_MOCK_DATA.default_fr_not_stepped_up,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },
    tokens_csr_not_stepped_up: {
        'gb-authorization': JWT_MOCK_DATA.default_csr_not_stepped_up,
        'mli-session-correlation-id': MLI_SESSION_CORRELATION_ID,
    },
};

export const ENTITLEMENTS_ALL_PERMIT = {
    memberEntitlements: [
        {
            resource: 'postaladdress',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'phonenumber',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'bankaccount',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'emailaddress',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'familymember',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'studentstatus',
            decision: 'permit',
            action: 'update',
        },
        {
            resource: 'cob',
            decision: 'permit',
            action: 'update',
        },
    ],
};

export const ENTITLEMENTS_ALL_INDETERMINATE = {
    memberEntitlements: [
        {
            resource: 'postaladdress',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'phonenumber',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'bankaccount',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'emailaddress',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'familymember',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'studentstatus',
            decision: 'indeterminate',
            action: 'update',
        },
        {
            resource: 'cob',
            decision: 'indeterminate',
            action: 'update',
        },
    ],
};

export const MEMBER_DATA = {
    member: {
        firstName: 'Bob',
        lastName: 'Basic',
        birthDate: '1985-01-01',
        effectiveDate: lastMonthString,
        gender: 'MALE',
        postalAddress: {
            addressId: '1',
            suite: '2a',
            status: 'ACTIVE',
            type: 'CANADAPOST',
            streetAddress: '123 Test Street',
            city: 'Testville',
            postalOrZipCode: 'A1A 1A1',
            country: 'CA',
            phoneNumber: '(111) 111-1111',
            stateOrProvince: 'ON',
        },
        emailAddress: 'test@testmail.com',
        bankAccount: {
            bankAccountId: '1',
            bankName: 'MANULIFE BANK OF CANADA',
            branchNumber: '05012',
            institutionNumber: '540',
            accountNumber: '123456789',
            status: 'ACTIVE',
            usage: 'HEALTH_AND_DENTAL_CLAIMS',
        },
        plan: {
            studentMaxAge: 25,
        },
    },
};

export const MEMBER_SUPPLEMENTAL_DATA = {
    member: {
        coverageAppliedDate: '2023-01-01',
    },
};

export const MEMBER_BENEFITS_DATA = {
    member: {
        benefits: [
            {
                memberBenefitId: '123',
                name: 'Health',
                cobRequired: true,
                hideCOBBenefit: false,
                status: 'ACTIVE',
                coverageType: 'SINGLE_PLUS_MORE',
                code: 'EHC',
                cob: {
                    hasOtherInsurer: true,
                    otherInsurerName: 'MANULIFE',
                },
            },
            {
                memberBenefitId: '456',
                name: 'Dental',
                cobRequired: true,
                hideCOBBenefit: false,
                status: 'ACTIVE',
                coverageType: 'SINGLE_PLUS_MORE',
                code: 'DEN',
                cob: {
                    hasOtherInsurer: true,
                    otherInsurerName: 'MANULIFE',
                },
            },
        ],
    },
};

export const DEFAULT_ERROR_STATE = {
    initialLoad: { hasError: false },
    familyMemberUpdate: { hasError: false },
    emailAddressUpdate: { hasError: false },
    postalAddressUpdate: { hasError: false },
    bankDataLoad: { hasError: false },
    bankDataUpdate: { hasError: false },
    tokenUpdate: { hasError: false },
    canadaPostAddressLoad: { hasError: false },
    dropDownSelectedAddressDetail: { hasError: false },
    commitContext: { hasError: false },
    purgeApplicationStateAndContext: { hasError: false },
    terminateCIAMSession: { hasError: false },
};

export const DEFAULT_AUTHENTICATION_STATE = {
    isAuthenticated: true,
    jwt: JWT_MOCK_DATA.default,
    language: 'en-CA',
    isCsr: false,
    sessionCorrelationId: MLI_SESSION_CORRELATION_ID,
    isCiamSession: true,
    isSteppedUp: true,
};

export const MOCK_VALID_CTX = {
    lang: LOCALE.EN_NO_REGION,
    channel: 'inbound-sso',
    origin: 'web',
    entityId: 'otip',
    selectedPlan: '123-1234',
    rsfId: '123456',
};

export const BASE64_ENCODED_MOCK_VALID_CTX = btoa(JSON.stringify(MOCK_VALID_CTX));

export const URL_ENCODED_MOCK_VALID_CTX = encodeURIComponent(BASE64_ENCODED_MOCK_VALID_CTX);

export const MOCK_INVALID_CTX = { lang: LOCALE.EN, channel: 'inbound-sso', origin: 'web' };

export const BASE64_ENCODED_MOCK_INVALID_CTX = btoa(JSON.stringify(MOCK_INVALID_CTX));

export const URL_ENCODED_MOCK_INVALID_CTX = encodeURIComponent(btoa(JSON.stringify(MOCK_INVALID_CTX)));
